// extracted by mini-css-extract-plugin
export default {"data-table":"DataTable_data-table__YRQ+Y","loading":"DataTable_loading__0-tXy","total":"DataTable_total__crS-X","no-columns":"DataTable_no-columns__Ulcju"};